import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface'
import { ProductDownloadItemErrorsType } from '../../../types/product-interface'

export const getProductDownloadError = (
  errors: ProductDownloadItemErrorsType,
  productErrors: DigitalProductErrorInterface,
) =>
  !!productErrors.name ||
  !!productErrors.resources?.length ||
  !!productErrors.confirmationEmail?.subject ||
  !!productErrors.confirmationEmail?.body ||
  !!productErrors.confirmationEmail?.fromName ||
  !!productErrors.confirmationEmail?.fromEmail ||
  !!productErrors.confirmationEmail?.previewText ||
  !!errors['digitalProduct.resources']
